/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/lib/utils.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export {cn};
//# sourceMappingURL=utils.js.map
